import Button from '@ui/Button'
import Breadcrumb from '@common/Breadcrumb'
import {ROUTES,SITE } from '@/constants'
import TransformBanner from '@sections/TransformBanner'
import MetaInfo from '@/components/common/MetaInfo'
import { metaTitleFor } from '../assets/js/navBreadcrumb'
const { label, pageDesc, metaDesc } = metaTitleFor(ROUTES.AI_MACHINE_LEARNING_SOLUTIONS)

const WE_CAN_BUILD = [
 {title: 'Predictive Analytics & Forecasting',
    desc: 'Use historical data and relevant variables to estimate future outcomes. Depending on the available data, models can support demand forecasting, workload planning, resource allocation and trend analysis.',
    subtitle1:'Example — Retail',
    example1:'A forecasting feature could estimate product demand from historical sales and seasonal patterns, helping inventory teams plan stock levels more effectively.' ,
    subtitle2:'Example — Operations',
    example2:'A service platform could forecast incoming workload to help managers plan staffing and operational capacity.' 
  },
  {title: 'Anomaly Detection',
    desc: 'Identify patterns or events that differ from expected behaviour and may require further investigation.',
    subtitle1:'Example — Energy & Utilities',
    example1:'An analytical platform could flag unusual consumption patterns or operational readings for inspection.' ,
    subtitle2:'Example — IT Operations',
    example2:`A monitoring solution could identify unusual system metrics that may indicate emerging performance or reliability issues.
    An anomaly is not automatically evidence of a fault or fraud. Detection results should be assessed in context and reviewed using suitable procedures` 
  },
{title: 'Classification & Intelligent Categorization',
    desc: 'Train or configure models to categorize information based on relevant patterns, helping applications organize large volumes of data.',
    subtitle1:'Example — Customer Service',
    example1:'An application could classify incoming support requests by topic and direct them to suitable teams.' ,
    subtitle2:'Example — Document Management',
    example2:'A platform could categorize submitted documents and suggest metadata to help users locate and process them.' 
  },
  {title: 'Recommendation & Ranking Systems',
    desc: 'Help applications prioritize or recommend relevant items using available user, product, content or interaction data.',
    subtitle1:'Example — E-commerce',
    example1:'A product platform could recommend items based on relevant purchase and browsing patterns.' ,
    subtitle2:'Example — Learning Platforms',
    example2:`A learning application could recommend suitable resources based on a learner's activity and progress, subject to appropriate safeguards.` 
  },
  {title: 'Predictive Maintenance',
    desc: 'Use historical maintenance records, sensor readings and equipment data—where available—to estimate the likelihood of equipment issues or identify conditions that merit inspection.',
    subtitle1:'Example — Manufacturing:',
    example1:`A maintenance platform could highlight equipment showing unusual operating patterns, helping teams prioritize inspections and investigate possible faults.
The usefulness of predictive maintenance depends on data quality, equipment context and sufficient historical examples.` ,
    subtitle2:'',
    example2:'' 
  },
  {title: 'AI-Enabled Analytics & Decision Support',
    desc: 'Integrate model outputs into dashboards and business applications, enabling users to view predictions, risk indicators, trends and relevant supporting information alongside their existing operational data.',
    subtitle1:'Example — Government Programme Monitoring',
    example1:'A dashboard could combine reported progress, historical trends and validated indicators to help administrators identify programmes or regions that may require attention. Predictions should support—not replace—official monitoring and decision-making.' ,
    subtitle2:'',
    example2:'' 
  },

    
  
  
]

const AI_CREATE_VALUES = [
  { title: 'Government & eGovernance',desc: 'Programme trend analysis, workload forecasting, anomaly identification and decision-support dashboards.' },
  { title: 'Energy & Utilities',desc: 'Consumption forecasting, unusual-pattern detection and maintenance planning.' },
  { title: 'Manufacturing',desc: 'Quality analysis, equipment monitoring, demand forecasting and predictive maintenance.' },
  { title: 'Retail & Distribution',desc: 'Demand planning, inventory forecasting, product recommendations and sales analysis.' },
  { title: 'Financial Services',desc: 'Transaction anomaly detection, risk indicators and document classification, subject to appropriate governance and validation.' },
  { title: 'Healthcare Operations',desc: 'Resource and appointment forecasting, administrative analytics and operational planning—not unvalidated clinical diagnosis.' }, 
  { title: 'Enterprise Software & SaaS',desc: 'Intelligent categorization, predictive features, recommendations and data-driven product capabilities.' }, 
]



const INTEGRATING_AI = [
  { title: `Define the Problem`, desc: 'Establish the business question, intended users and measurable outcome.', },
  { title: 'Assess the Data', desc: 'Review data availability, quality, coverage, permissions and suitability for the intended model.', },
  { title: 'Develop & Evaluate', desc: 'Select appropriate techniques, establish baselines and evaluate model performance against relevant test data.', },
  { title: 'Integrate With Applications', desc: 'Deliver model outputs through APIs, dashboards, business applications or operational workflows.', },
  { title: 'Monitor & Maintain', desc: 'Track performance, data changes and model limitations, with retraining or adjustment where justified.', },
  
]
export default function AiMachineLearning() {
  

  return (
    <>
     <MetaInfo
      title={`${label} ${SITE.metaTagPostText}`} 
      description={metaDesc}
      keywords=""
      />
      <main id="main-content" className="page-wrapper">
         <div className="page-hero">
           <div className="bg-grid bg-grid--fill" aria-hidden="true" />
           <div className="container">
             {/* <div className="section-label">- AI/ML Solutions -</div> */}
             <Breadcrumb />
             <h1 data-aos="fade-up" data-aos-delay={100}>
              {/* Conversational AI Solutions */}
              {label}
             </h1>
             <p className="page-subtitle" data-aos="fade-up" data-aos-delay={200}>
             {/* Build intelligent chatbots that deliver natural, human-like conversations. */}
             {pageDesc}
             </p>
             
             <div className="inner-page-actions">
               <Button  href={ROUTES.SALES_ENQUIRY}  variant="primary" icon="fa-arrow-right" iconPos="right" data-aos="fade-up" data-aos-delay={300}>
                 Get a Free Quote
               </Button>
              
             </div>
           </div>
         </div>

          {/* section 1 */}
          <section className="bg-linear-gradient-light section-py " >
        <div className="container">
              
  
          {/* Row 2 — */}
            <p className='text-center' data-aos="fade-down">
             Business applications generate and manage valuable data every day—from transactions and service requests to equipment readings, operational reports and customer interactions. When analyzed effectively, this information can help organizations recognize patterns, anticipate changes and make better-informed decisions.
            </p>
        
              <p className='text-center' data-aos="fade-down">
                Artificial Intelligence and Machine Learning (ML) provide techniques for identifying patterns in data, generating predictions, classifying information and detecting unusual behaviour. These capabilities can be integrated into existing software platforms, analytical dashboards and operational systems.
            </p>
            <p className='text-center' data-aos="fade-down">
              CruxBytes can help businesses explore and develop data-driven AI capabilities that complement their current applications. Our focus is on practical use cases where data, appropriate models and well-designed software can address a defined business problem.
            </p>
            <h6 className='pt-4 text-center'>Machine Learning Capabilities for Business Applications</h6>
          <div className="wcs-grid wcs-grid--3 pt-4">
            {WE_CAN_BUILD.map((card, i) => (
              <div
                key={card.title}
                className="wcs-card-offer"
                data-aos="fade-left"
                data-aos-delay={(i % 3) * 80}
              >
                {/* <i className={`${card.icon} wcs-icon`} aria-hidden="true" /> */}
                <h3 className="wcs-offer-title">{card.title}</h3>
                <p className="wcs-offer-desc" style={{ whiteSpace: 'pre-line' }}>{card.desc}</p>
                
                {card.example1 !== "" && <><h6 className='pt-4'>{card.subtitle1}</h6> 
                <p className="wcs-offer-desc" style={{ whiteSpace: 'pre-line' }}>{card.example1}</p></>}
                {card.example2 !== "" && <><h6 className='pt-4'>{card.subtitle2}</h6> 
                <p className="wcs-offer-desc" style={{ whiteSpace: 'pre-line' }}>{card.example2}</p></>}
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* section 2 */}
      <section className="section-py " aria-labelledby="pux-outcomes-heading">
    <div className="container">
      <div className="sc-ai-row sc-tm-row--sticky-heading">
        <div className="sc-tm-content" data-aos="fade-left">        
        <h2 id="impact-heading" >
              <span className="impact-heading-dark">Industry</span>
              <span className="impact-heading-light">Applications</span>
            </h2>
            
        </div>
        <div  data-aos="fade-right">
          <div className="wcs-grid wcs-grid--3">
            {AI_CREATE_VALUES.map((card, i) => (
              <div
                key={card.title}
                className="wcs-card wcs-card--static wcs-card--start  bg-peach"
                data-aos="fade-up"
                data-aos-delay={(i % 3) * 80}
              >             
                <h3 className="wcs-title"  >{card.title}</h3>
                <p className="wcs-desc">{card.desc}</p>
              </div>
            ))}
          </div>
        </div>
  
      </div>
      
    <div className="comparison-intro mb-0" data-aos="fade-left">
    <div className='pt-4 d-flex align-items-center'>
      <h5>Turn Business Data into More Informed Decisions</h5>
  </div>
  
    <div className="wcs-actions comparison-intro-cta ms-4"  data-aos="fade-right">
      <Button href={ROUTES.SALES_ENQUIRY} variant="primary" icon="fa-arrow-right" iconPos="right">
                    Get Started
        </Button>
    </div>
  </div>
    </div>
  </section>
  
    {/* ── Section 3 */}
          <section className="section-py  bgs-section--tint" aria-labelledby="egovernance-partner-heading" style={{ borderRadius:"0" }}>
            
  
            <div className="container">
              <div className="" data-aos="fade-up">
                <div className="section-card__content ">
                  <h2 className='text-center' id="egovernance-partner-heading">
                    From Data to a Useful Software Feature
                  </h2>
                  
                </div>
            <p data-aos="fade-up" className='section-px2'>Developing a successful ML solution involves more than selecting an algorithm. The data must be suitable for the task, the model must be evaluated against meaningful criteria and the result must fit into the application where people will use it.
</p><p data-aos="fade-up" className='section-px2'>Our approach can include:</p>
              <div className="wcs-grid">
                {INTEGRATING_AI.map((item, i) => (
                  <div
                    key={item.title}
                    className="wcs-card  wcs-card-5  bg-white"
                    data-aos="fade-up"
                    data-aos-delay={i * 80}
                  >
                    <h3 className="text-secondary wcs-title" >0{i+1}</h3>
                    {i > 0 && <div className="sc-code-divider" aria-hidden="true" />}
                    {/* <i className={`fa-solid ${item.icon} wcs-icon`} aria-hidden="true" /> */}
                    <h3 className="text-secondary wcs-title">{item.title}</h3>
                    <p className="text-secondary wcs-desc">{item.desc}</p>
                  </div>
                ))}
              </div>
              
              
              </div>
              <p data-aos="fade-up" className='section-px2 pt-4'>The right method may range from established statistical techniques to supervised or unsupervised machine learning. Not every problem requires a complex AI model; sometimes simpler analytics or rule-based logic provides a more reliable and economical answer.
</p>
            </div>
          </section>
            {/* Section4 */}
        <section className="section-py ">
                  <div className="container ">
          <div className="on-demand-split">
                    {/* ── LEFT ── */}
            <div className="cp-timeline" data-aos="fade-right" aria-label="Our hiring process">
          
            <div className="cp-timeline-header">
              <h2 >Practical AI, Built Around Your Data</h2>
              <p >
              We consider data quality, explainability, integration, security, operating costs and the consequences of incorrect predictions when shaping a solution. Where decisions have significant consequences, suitable human review and governance are essential.
              </p>
              <p>Whether you want to introduce forecasting into an existing dashboard, build intelligent features into a SaaS product or explore predictive capabilities within an operational system, CruxBytes can help connect data science techniques with practical software engineering.</p>
            </div>     
          </div>
                            {/* ── RIGHT:  ── */}
            <div   data-aos="fade-left">  
              <div className="contact-form-wrap" style={{backgroundColor:'var(--brand-100)'}}>
                <h6>Make Your Business Applications More Data-Driven</h6>
                <p style={{ paddingBottom: '1.2rem' }}>
                  Explore how AI and machine learning can turn suitable business data into useful predictions, insights and capabilities within your existing digital platforms.

                </p>
                
              </div>
            </div>
  
                    </div>
            
                  </div>
            </section>
         <TransformBanner />
         </main></>
  )
}